import { Grid } from "@mui/material";
import {
  DateTimeInput,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
  useRecordContext,
} from "react-admin";
import { paymentRequests } from "api/paymentApi";
import { DoctoralSchoolCampaignStatusChoices } from "utils/choices";

const SaveForm = () => {
  const record = useRecordContext();
  const isEdit = !!record?.id;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <DateTimeInput
          label="Начало на училището"
          source="dateFrom"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <DateTimeInput
          label="Край на училището"
          source="dateTo"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <DateTimeInput
          label="Записване от"
          source="enrollmentFrom"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <DateTimeInput
          label="Записване до"
          source="enrollmentTo"
          validate={required()}
          fullWidth
        />
      </Grid>
      {isEdit && (
        <>
          <Grid item xs={12} md={6}>
            <ReferenceInput source="ibanId" reference={paymentRequests.getIbansSelect()}>
              <SelectInput label="IBAN за плащане" optionText="name" fullWidth />
            </ReferenceInput>
          </Grid>
          <Grid item xs={12} md={6}>
            <SelectInput
              label="Статус"
              source="status"
              choices={DoctoralSchoolCampaignStatusChoices}
              validate={required()}
              fullWidth
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SaveForm;
